(() => {
  const initialize = () => {
    document.querySelectorAll('.sa-gallery').forEach(gallery => {
      if (gallery.dataset.ready) return;
      gallery.dataset.ready = 'true';
      const stage = gallery.querySelector('.sa-gallery__stage');
      const main = gallery.querySelector('.sa-gallery__main');
      const buttons = [...gallery.querySelectorAll('[data-photo]')];
      if (!main || !buttons.length) return;
      const mobile = matchMedia('(max-width:700px)');
      const reduced = matchMedia('(prefers-reduced-motion:reduce)');
      let active = 0;
      const rail = document.createElement('div');
      rail.className = 'sa-gallery__rail';
      rail.setAttribute('aria-label', 'Galería deslizable');
      rail.tabIndex = 0;
      rail.style.aspectRatio = main.width / main.height;
      const slides = buttons.map((button, index) => {
        const slide = document.createElement('div');
        slide.className = 'sa-gallery__slide';
        const image = new Image();
        image.alt = button.dataset.alt || button.getAttribute('aria-label');
        image.width = Number(button.dataset.width);
        image.height = Number(button.dataset.height);
        image.decoding = 'async';
        image.dataset.src = button.dataset.photo;
        slide.append(image); rail.append(slide);
        return image;
      });
      stage.prepend(rail);
      const preload = index => {
        [index - 1, index, index + 1].forEach(i => {
          const image = slides[i];
          if (image && !image.getAttribute('src')) image.src = image.dataset.src;
        });
      };
      const select = index => {
        active = index;
        buttons.forEach((b,i) => b.setAttribute('aria-pressed', String(i === index)));
        if (mobile.matches) preload(index);
      };
      const desktop = () => {
        main.removeAttribute('srcset');
        main.src = buttons[active].dataset.photo;
        main.alt = buttons[active].dataset.alt;
      };
      const go = index => {
        index = Math.max(0, Math.min(buttons.length - 1, index));
        if (mobile.matches) {
          preload(index);
          rail.scrollTo({left:index * rail.clientWidth,behavior:reduced.matches ? 'instant' : 'smooth'});
        } else { select(index); desktop(); }
      };
      let frame;
      rail.addEventListener('scroll', () => {
        if (frame) return;
        frame = requestAnimationFrame(() => {
          frame = null;
          if (rail.clientWidth) select(Math.round(rail.scrollLeft / rail.clientWidth));
        });
      }, {passive:true});
      rail.addEventListener('keydown', event => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault(); go(active + (event.key === 'ArrowRight' ? 1 : -1));
        }
      });
      new ResizeObserver(() => {
        if (mobile.matches) rail.scrollTo({left:active * rail.clientWidth,behavior:'instant'});
      }).observe(rail);
      mobile.addEventListener('change', () => { if (mobile.matches) preload(active); else desktop(); });
      if (mobile.matches) preload(0);
      gallery.addEventListener('click', event => {
        const dialog = gallery.querySelector('.sa-image-dialog');
        if (event.target.closest('.sa-gallery__zoom')) {
          dialog.querySelector('img').src = mobile.matches ? slides[active].src : main.currentSrc;
          dialog.querySelector('img').alt = buttons[active].dataset.alt;
          dialog.showModal(); return;
        }
        if (event.target.closest('[data-close-image]')) { dialog.close(); return; }
        const button = event.target.closest('[data-photo]');
        if (button) go(buttons.indexOf(button));
      });
    });
    const catalogue = document.querySelector('[data-catalogue]');
    if (catalogue) {
      const pathFamily = (location.pathname.match(/\/collections\/(coccion|lavado|conservacion)(?:\/|$)/) || [])[1];
      const family = pathFamily || new URLSearchParams(location.search).get('familia') || 'all';
      const labels = { all: 'Todos los equipos', coccion: 'Cocción', lavado: 'Lavado', conservacion: 'Conservación', accesorios: 'Accesorios' };
      const active = Object.hasOwn(labels, family) ? family : 'all';
      catalogue.querySelector('h1').textContent = labels[active];
      const accessories = catalogue.querySelector('.sa-accessories');
      if (accessories) accessories.hidden = active !== 'accesorios';
      catalogue.querySelectorAll('[data-family]').forEach(card => { card.hidden = active !== 'all' && card.dataset.family !== active; });
      catalogue.querySelectorAll('[data-family-filter]').forEach(link => {
        if (link.dataset.familyFilter === active) link.setAttribute('aria-current', 'page');
        else link.removeAttribute('aria-current');
      });
    }
    const select = document.getElementById('SAProduct');
    if (select && !select.dataset.ready) {
      select.dataset.ready = 'true';
      const handle = new URLSearchParams(location.search).get('producto');
      const option = Array.from(select.options).find(option => option.dataset.handle === handle);
      if (option) select.value = option.value;
    }
  };
  initialize();
  document.addEventListener('shopify:section:load', initialize);
})();


(() => {
 const money = new Intl.NumberFormat('es-CO', {style:'currency',currency:'COP',maximumFractionDigits:0});
 const number = new Intl.NumberFormat('es-CO', {maximumFractionDigits:1});
 function init(root = document) {
  root.querySelectorAll('[data-time-calculator]').forEach(form => {
   if(form.dataset.initialized)return;form.dataset.initialized='true';
   const scenario=form.querySelector('[data-calc-scenario]'), result=form.querySelector('[data-time-result]'), error=form.querySelector('[data-calc-error]');
   let summary;
   form.addEventListener('submit',event=>{
    event.preventDefault();if(!form.reportValidity())return;
    const f=new FormData(form);
    const d={volume:Number(f.get('volume')),people:Number(f.get('people')),hours:Number(f.get('hours')),salary:Number(String(f.get('salary')).replace(/[., ]/g,'')),days:Number(f.get('days')),shift:Number(f.get('shift'))};
    error.hidden=true;summary=undefined;
    if(Object.values(d).some(v=>!Number.isFinite(v)||v<=0)||d.hours>d.shift){error.textContent=d.hours>d.shift?'Las horas de esta tarea no pueden superar la jornada diaria por persona. Revisa el tiempo o ajusta la jornada.':'Revisa los datos: escribe valores mayores que cero.';error.hidden=false;scenario.hidden=true;return;}
    const hours=d.hours*d.people*d.days, cost=hours*d.salary/d.days/d.shift, unitCost=cost/(d.volume*d.days);
    const unit=form.dataset.volumeUnit;
    result.replaceChildren();
    for(const [amount,label] of [[money.format(cost),'al mes en tiempo de trabajo para esta tarea'],[number.format(hours)+' horas','de trabajo al mes entre todas las personas'],[money.format(unitCost),'de trabajo por unidad ('+unit+')']]){
     const item=document.createElement('div');item.className='sa-time-metric';const strong=document.createElement('strong'),span=document.createElement('span');strong.textContent=amount;span.textContent=label;item.append(strong,span);result.append(item);
    }
    const baseline=document.createElement('p');baseline.textContent=number.format(d.volume)+' '+unit+' al día · '+d.people+' persona(s) · '+number.format(d.hours)+' horas diarias por persona.';result.append(baseline);
    summary={handle:form.dataset.productHandle,volume:number.format(d.volume)+' '+unit+' al día',body:'Quiero comparar mi operación con '+form.dataset.productTitle+'.\nVolumen: '+d.volume+' '+unit+'/día.\nPersonas: '+d.people+'. Horas diarias de esta tarea por persona: '+d.hours+'.\nCosto mensual por persona: '+money.format(d.salary)+'. Jornada: '+d.days+' días/mes, '+d.shift+' horas/día.\nCosto de trabajo actual calculado: '+money.format(cost)+'/mes; '+number.format(hours)+' horas/mes.\nSolicito estimar el tiempo y costo con el equipo para el mismo volumen, incluyendo carga, descarga, limpieza y consumos. Ahorro todavía no calculado.'};
    scenario.hidden=false;scenario.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'nearest'});
   });
   form.addEventListener('input',()=>{scenario.hidden=true;error.hidden=true;summary=undefined;form.querySelector('[data-schedule-label]').textContent=form.elements.days.value+' días al mes · '+form.elements.shift.value+' horas al día';});
   form.querySelector('[data-calc-handoff]').addEventListener('click',event=>{
    if(!summary){event.preventDefault();return;}
    try{sessionStorage.setItem('sa-operation-comparison',JSON.stringify(summary));}catch{
     event.preventDefault();error.textContent='No pudimos trasladar los datos automáticamente. Copia el resumen para compartirlo con el asesor: '+summary.body;error.hidden=false;
    }
   });
  });
  const contact=root.querySelector('#SAContact');
  if(contact && !contact.dataset.comparisonReady){
   contact.dataset.comparisonReady='true';
   try{
    const saved=JSON.parse(sessionStorage.getItem('sa-operation-comparison')||'null');
    const current=new URLSearchParams(location.search).get('producto');
    if(saved && saved.handle===current && typeof saved.body==='string' && typeof saved.volume==='string'){
     const body=contact.querySelector('textarea[name="contact[body]"]'),volume=contact.querySelector('input[name="contact[Volumen]"]');
     if(body && !body.value){body.value=saved.body;if(volume&&!volume.value)volume.value=saved.volume;sessionStorage.removeItem('sa-operation-comparison');}
    }
   }catch{}
  }
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init());else init();
 document.addEventListener('shopify:section:load',event=>init(event.target));
})();

// Native, silent video: play only while visible, with no player chrome.
(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  function init(root = document) {
    root.querySelectorAll('[data-sa-autoplay]').forEach(video => {
      if (video.dataset.initialized) return;
      video.dataset.initialized = 'true';
      const card = video.closest('.sa-video-card');
      const toggle = card.querySelector('[data-sa-video-toggle]');
      const fallback = card.querySelector('.sa-video-fallback');
      let visible = false;
      let manuallyPaused = false;
      const label = () => {
        toggle.textContent = video.paused ? 'Reanudar' : 'Pausar';
        toggle.setAttribute('aria-label', (video.paused ? 'Reanudar' : 'Pausar') + ' video');
      };
      const play = () => {
        video.muted = true;
        const attempt = video.play();
        if (attempt) attempt.catch(() => { toggle.textContent = 'Reproducir'; });
      };
      video.addEventListener('play', label);
      video.addEventListener('pause', label);
      video.addEventListener('error', () => { fallback.hidden = false; toggle.hidden = true; });
      toggle.addEventListener('click', () => {
        manuallyPaused = !video.paused;
        if (manuallyPaused) video.pause(); else play();
      });
      const observer = new IntersectionObserver(entries => {
        visible = entries[0].isIntersecting;
        if (visible && !document.hidden && !reduced.matches && !manuallyPaused) play();
        else video.pause();
      }, { threshold: 0.35 });
      observer.observe(video);
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) video.pause();
        else if (visible && !reduced.matches && !manuallyPaused) play();
      });
      reduced.addEventListener('change', () => {
        if (reduced.matches) video.pause();
        else if (visible && !document.hidden && !manuallyPaused) play();
      });
      label();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

(() => {
 const init = () => {
  document.querySelectorAll('.sa-categories').forEach(section => {
   if(section.dataset.carouselReady) return;
   section.dataset.carouselReady='true';
   const rail=section.querySelector('.sa-categories__rail'), items=[...rail.children], controls=section.querySelector('.sa-category-controls');
   if(!controls || !items.length) return;
   const prev=controls.querySelector('[data-category-prev]'), next=controls.querySelector('[data-category-next]'), count=controls.querySelector('[data-category-count]');
   let active=0;
   const update=()=>{
    const step=items.length>1?items[1].offsetLeft-items[0].offsetLeft:items[0].clientWidth;
    active=Math.max(0,Math.min(items.length-1,Math.round(rail.scrollLeft/step)));
    count.textContent=`${active+1} / ${items.length}`;
    controls.style.setProperty('--category-index',active);
    prev.disabled=active===0;next.disabled=active===items.length-1;
   };
   const go=delta=>{
    const target=Math.max(0,Math.min(items.length-1,active+delta));
    rail.scrollTo({left:items[target].offsetLeft-items[0].offsetLeft,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});
   };
   prev.addEventListener('click',()=>go(-1));next.addEventListener('click',()=>go(1));rail.addEventListener('scroll',update,{passive:true});new ResizeObserver(update).observe(rail);controls.hidden=false;update();
  });
  document.querySelectorAll('.sa-allies-pause').forEach(button=>{
   if(button.dataset.ready) return;button.dataset.ready='true';
   button.addEventListener('click',()=>{const paused=button.getAttribute('aria-pressed')!=='true';button.setAttribute('aria-pressed',String(paused));button.textContent=paused?'Reanudar movimiento':'Pausar movimiento';});
  });
 };
 if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init);else init();
 document.addEventListener('shopify:section:load',init);
})();

// A quote needs only name, WhatsApp and city. Sending remains explicit in WhatsApp.
(() => {
 function init(root=document) {
  root.querySelectorAll('[data-whatsapp-contact]').forEach(form => {
   if(form.dataset.whatsappReady)return;
   form.dataset.whatsappReady='true';form.hidden=false;
   form.addEventListener('submit',event=>{
    event.preventDefault();
    if(!form.reportValidity())return;
    const data=new FormData(form);
    const value=key=>String(data.get('contact['+key+']')||'').trim();
    const lines=['Hola, quiero cotizar y coordinar la entrega.', 'Nombre: '+value('name'),'WhatsApp: '+value('phone'),'Ciudad: '+value('Ciudad'),'Equipo: '+(value('Equipo')||'Quiero ayuda para elegir')];
    if(value('Volumen'))lines.push('Volumen: '+value('Volumen'));
    if(value('body'))lines.push('Detalles: '+value('body'));
    const selected=form.querySelector('#SAProduct option:checked');
    if(selected?.dataset.handle && selected.dataset.handle!=='accesorios')lines.push(location.origin+'/products/'+selected.dataset.handle);
    const target='https://wa.me/573161234591?text='+encodeURIComponent(lines.join('\n'));
    saTrack('sa_cotizacion_whatsapp',{producto:selected?.dataset.handle||'ayuda-para-elegir',pagina:location.pathname});
    setTimeout(()=>location.assign(target),250);
   });
  });
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init());else init();
 document.addEventListener('shopify:section:load',event=>init(event.target));
})();

// Medición sin datos personales: eventos personalizados de Shopify para conectar GA4/Meta desde Customer events.
function saTrack(name,detail){try{window.Shopify?.analytics?.publish?.(name,detail||{});}catch(e){}}
document.addEventListener('click',event=>{
 const link=event.target.closest?.('a[href*="wa.me/"]');
 if(!link)return;
 const origin=link.classList.contains('sa-whatsapp')?'flotante':link.closest('footer,.sa-footer')?'pie':'contenido';
 saTrack('sa_whatsapp_click',{origen:origin,producto:document.querySelector('[data-product]')?.dataset.product||'',pagina:location.pathname});
});

// Barra fija de cotización en móvil: aparece cuando el botón principal sale de pantalla y antes del cierre de la ficha.
(() => {
 function init(){
  const bar=document.querySelector('[data-sticky-quote]');
  const main=document.querySelector('.sa-pdp-summary .sa-btn--accent');
  const end=document.querySelector('.sa-pdp-end');
  if(!bar||!main||bar.dataset.ready)return;
  bar.dataset.ready='true';
  const link=bar.querySelector('[data-sticky-quote-link]');
  let mainOut=false,endIn=false;
  const update=()=>{
   const show=mainOut&&!endIn;
   bar.classList.toggle('is-visible',show);
   bar.setAttribute('aria-hidden',show?'false':'true');
   link.tabIndex=show?0:-1;
   document.body.classList.toggle('sa-sticky-on',show);
  };
  new IntersectionObserver(([e])=>{mainOut=!e.isIntersecting&&e.boundingClientRect.top<0;update();}).observe(main);
  if(end)new IntersectionObserver(([e])=>{endIn=e.isIntersecting;update();}).observe(end);
  link.addEventListener('click',()=>saTrack('sa_cotizar_click',{origen:'barra_movil',producto:document.querySelector('[data-product]')?.dataset.product||'',pagina:location.pathname}));
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
